<div class="jsd-privacy-policy">
    <div class="jsd-privacy-policy_slogan">
        <h2>POLÍTICA DE PRIVACIDADE</h2>
        <h1>JAMES DELIVERY</h1>
    </div>

    <h3>DATA DA ÚLTIMA ATUALIZAÇÃO: 24/05/2021.</h3>

    <p>
        A <b> JAMES INTERMEDIAÇÃO DE NEGÓCIOS LTDA</b>, empresa inscrita no CNPJ/MF sob o nº 23.881.322/0001-92 ("James"
        ou "nós"), possui o aplicativo James Delivery e o website
        <a href="https://www.jamesdelivery.com.br">James Delivery</a> ("Plataformas Digitais"), que
        conectam clientes, entregadores e estabelecimentos, a fim de que sejam realizadas compras de determinados
        produtos ("Serviços"). Nós somos uma subsidiária integral da <b>COMPANHIA BRASILEIRA DE DISTRIBUIÇÃO</b>,
        inscrita no CNPJ/MF sob o nº 47.508.411/0001-56 ( <u>"GPA Pão de Açúcar"</u> ou <u>"GPA"</u>), que possui os <u>programas
        de fidelidade</u> "cliente mais" e "clube extra" (<u>"Programas de Fidelidade"</u>).
    </p>
    <p>
        Nós nos comprometemos em resguardar sua privacidade e proteger seus dados pessoais, e o intuito deste documento
        é esclarecer quais dados são coletados dos usuários que utilizam nossas Plataformas ("você").
    </p>
    <p>
        Neste aviso de privacidade ("Aviso de Privacidade" ou "Aviso"), você vai encontrar informações sobre como
        coletamos, usamos, armazenamos e compartilhamos os seus Dados Pessoais ("Dados Pessoais" ou "Dados"). Este
        documento é parte integrante dos nossos <a href="/termo-de-uso">Termos de Uso</a>, que contém uma visão geral das
        nossas Plataformas.
    </p>
    <p>
        ESTE AVISO DEVE SER CONSIDERADO EM CONJUNTO COM A POLITICA DE
        PRIVACIDADE DO GPA. NOS CASOS EM QUE O
        ENTENDIMENTO DESTE AVISO PAREÇA CONTRADIZER A POLÍTICA DE PRIVACIDADE DO GPA, PEDIMOS QUE VOCÊ CONSIDERE ESTE
        AVISO.
    </p>
    <div>
        <h3>Mas por que o James trata meus dados pessoais?</h3>
        <p>
            Quando realizamos uma venda, é comum coletarmos alguns dados pessoais dos clientes para efetivar uma compra
            –
            por exemplo, dados de cartão de crédito. Da mesma forma, parte dos nossos serviços podem envolver a
            realização de cadastros, seja para participar do nosso programa, seja para receber compras em sua casa.
        </p>
        <p>
            Esses são só alguns exemplos que mostram como nossas atividades precisam utilizar dados pessoais, de forma
            legítima e dentro de suas expectativas. Se, após a leitura deste Aviso, você ainda tiver dúvidas, fique à
            vontade para entrar em contato conosco pelo nosso e-mail <a href="mailto:cliente@jamesdelivery.com.br"> {{
                'cliente@jamesdelivery.com.br'
            }}</a> ou telefone <a href="tel:0800 8789 887">0800 8789 887</a>.
        </p>
        <ol>
            <li>
                <h3>Quais Dados Pessoais podem ser coletados e para quais finalidades eles podem ser tratados? </h3>
                <p>
                    A coleta dos seus Dados dependerá da interação que você tem com nossos Serviços. Coletaremos
                    diferentes dados caso você esteja visitando nosso website ou realizando compras em nosso
                    aplicativo.
                    E para tornar mais acessível essas definições e diferenças, elaboramos a tabela abaixo para que
                    você
                    possa compreender o que se aplica especificamente à você.
                </p>

                <table class="jsd-privacy-policy_table">
                    <tbody class="jsd-privacy-policy_table-tbody">
                    <tr>
                        <td class="even"><b>Finalidade</b></td>
                        <td class="odd"><b>Tipo de Dados Coletados </b></td>
                        <td class="even"><b>Base Legal </b></td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Analytics</b>: Análise de campanhas de marketing e performance, BI
                        </td>
                        <td class="oddBody">ID do usuário, E-mail, ID do pedido</td>
                        <td class="evenBody">Consentimento</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Registro de acesso</b>: cumprir com as obrigações legais de guarda
                            de
                            IP, data e hora de acesso ao nosso Site
                        </td>
                        <td class="oddBody">Dados de Navegação (IP, data e hora) e Dados do Dispositivo de Acesso
                        </td>
                        <td class="evenBody">Cumprimento de Obrigação Legal</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Anúncio</b>: Dados utilizados para o envio de anúncios</td>
                        <td class="oddBody">Nome, e-mail, tipo de público e Dados do Dispositivo de Acesso</td>
                        <td class="evenBody">Consentimento</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Funcionamento da plataforma</b>: Dado utilizado pelo aplicativo para
                            exibir os estabelecimentos próximos
                        </td>
                        <td class="oddBody">Localização (latitude / longitude) ou endereços</td>
                        <td class="evenBody">Consentimento</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Prestação dos Serviços</b>: Dados utilizados para executar o
                            pagamento
                            por determinada comprar e liberar o processo de entrega
                        </td>
                        <td class="oddBody">CPF, telefone, Endereços de entrega, CEP, Bairro, Cidade, Dados do
                            cartão de
                            crédito, dados da compra
                        </td>
                        <td class="evenBody">Execução de contrato ou procedimentos preliminares</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Marketing</b>: Análise de audiência de marketing</td>
                        <td class="oddBody">Nome, E-mail, Telefone, Histórico de pedidos</td>
                        <td class="evenBody">Legítimo Interesse</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>SMS marketing</b>: Envio de SMS marketing</td>
                        <td class="oddBody">Nome, celular</td>
                        <td class="evenBody">Consentimento</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Suporte ao cliente</b>: Dados utilizados para entrar em contato com
                            a
                            central de suporte (telefone)
                        </td>
                        <td class="oddBody">CPF, Telefone, Endereços de entrega, CEP, Bairro, Cidade, Histórico de
                            pedidos
                        </td>
                        <td class="evenBody">Legítimo Interesse</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Cadastro</b>: Dados utilizados para permitir o acesso ao aplicativo
                        </td>
                        <td class="oddBody">Nome, E-mail, Senha</td>
                        <td class="evenBody">Consentimento</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Adesão aos Programas de Fidelidade</b>: inclusão de usuários nos
                            programas de fidelidade Cliente Mais e Clube Extra do GPA.
                        </td>
                        <td class="oddBody">Nome, e-mail, CPF</td>
                        <td class="evenBody">Legítimo Interesse</td>
                    </tr>
                    <tr>
                        <td class="evenBody"><b>Redes sociais</b>: Resposta de mensagens, análise de audiência</td>
                        <td class="oddBody">Dados publicamente acessíveis do perfil do usuário na rede social</td>
                        <td class="evenBody">Legítimo Interesse</td>
                    </tr>
                    </tbody>
                </table>
            </li>
            <li>
                <h3>Quais são seus direitos enquanto titular dos Dados Pessoais?</h3>
                <p>
                    Os Dados Pessoais são seus, e a lei brasileira garante que você tenha uma série de direitos
                    relacionados a eles, que são os seguintes:
                </p>
                <ul>
                    <li>
                        <p>
                            Solicitar o acesso aos seus Dados Pessoais;
                        </p>
                    </li>
                    <li>
                        <p>
                            Solicitar o acesso aos seus Dados Pessoais; </p>
                    </li>
                    <li>
                        <p>
                            Solicitar a eliminação dos seus Dados Pessoais; </p>
                    </li>
                    <li>
                        <p>
                            Opor-se ao tratamento dos seus Dados Pessoais; </p>
                    </li>
                    <li>
                        <p>
                            Solicitar a portabilidade dos seus Dados Pessoais; </p>
                    </li>
                    <li>
                        <p>
                            Solicitar informação sobre o compartilhamento dos seus Dados Pessoais; </p>
                    </li>
                    <li>
                        <p>
                            Revogar um consentimento dado anteriormente; </p>
                    </li>
                    <li>
                        <p>
                            Solicitar a revisão de decisões automatizadas. </p>
                    </li>
                </ul>

                <p>
                    Você pode exercer esses direitos a qualquer tempo, por meio de nossos canais de atendimento <a
                        href="mailto:cliente@jamesdelivery.com.br"> {{
                        'cliente@jamesdelivery.com.br'
                    }}</a> ou telefone <a href="tel:0800 8789 887">0800 8789 887</a>. A nossa POLÍTICA DE PRIVACIDADE DO
                    GPA conta
                    com uma explicação detalhada sobre a forma pela qual você pode exercer cada um desses direitos.
                    Assim, para mais informações, pedimos para que acesse nossa Política.
                </p>
            </li>
            <li>
                <h3>Com quem seus Dados serão compartilhados?</h3>
                <p>O James, assim como qualquer empresa de tecnologia, opera em parceria com uma série de outras
                    empresas para oferecer seus Serviços. Dessa forma, podemos compartilhar seus Dados Pessoais com
                    essas empresas, sempre buscando preservar ao máximo a sua privacidade e, sempre que possível, de
                    forma anonimizada. Aqui descrevemos situações em que vamos compartilhar os Dados Pessoais:</p>
                <ul>
                    <li>
                        <p>
                            <b>Empresas do Grupo Pão de Açúcar.</b> Podemos compartilhar suas informações com outras
                            empresas
                            do GPA, as quais estão de acordo com a POLÍTICA DE PRIVACIDADE DO GPA e Avisos de
                            Privacidade específicos. Fazemos isso para atender aos legítimos interesses do GPA, como
                            para a inclusão de clientes nos Programas de Fidelidade Cliente Mais e Clube Extra do GPA. O
                            compartilhamento de Dados Pessoais para a inclusão nos Programas de fidelidade apenas
                            acontecerá caso você adquira algum produto nas marcas Pão de Açúcar ou Extra.</p>
                    </li>
                    <li>
                        <p><b>Nossos fornecedores e parceiros comerciais.</b> Temos uma série de fornecedores e
                            parceiros
                            comerciais que precisamos contratar para operar nossos serviços, e alguns deles podem tratar
                            Dados Pessoais que coletamos, como por exemplo, empresas que prestam serviços de hospedagem
                            de dados, de segurança patrimonial, de autenticação e validação de cadastros, empresas de
                            publicidade, meios de pagamento, entre outros. Na medida do possível, sempre buscamos
                            avaliar cuidadosamente nossos fornecedores e parceiros comerciais e firmar com eles
                            obrigações contratuais de segurança da informação e proteção de Dados Pessoais, com o
                            objetivo de minimizar riscos para os titulares.</p>
                    </li>
                    <li>
                        <p>Redes sociais. Algumas de nossas Plataformas Digitais permitem que você se cadastre fazendo o
                            login de sua conta por um serviço de terceiro, como seu perfil no Facebook ou no Google.
                            Quando isso acontece, certos Dados Pessoais poderão ser compartilhados com esses terceiros.
                            É sempre escolha sua se deseja ou não integrar essas informações. Lembramos que não
                            controlamos as políticas e práticas de qualquer outro site ou serviço de terceiros.</p>
                    </li>
                    <li>
                        <p>
                            <b>Empresas de Dados.</b> Alguns dos nossos parceiros comerciais são empresas de dados,
                            popularmente conhecidas como bureaus, com as quais podemos compartilhar Dados Pessoais para
                            algumas finalidades importantes, como validar um determinado perfil para evitar fraudes,
                            para subsidiar a concessão de crédito, para liberação de venda a prazo ou, ainda, para a
                            realização de outras transações comerciais e empresariais que impliquem risco financeiro.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Estabelecimentos Comerciais.</b> Além de nossos fornecedores, precisamos também
                            compartilhar
                            Dados Pessoais com os estabelecimentos comerciais, com o objetivo de viabilizar a venda de
                            determinado produto por meio de nosso aplicativo. Da mesma forma como fazemos com nossos
                            fornecedores, envidamos nossos melhores esforços para avaliar cuidadosamente nossos
                            parceiros comerciais e firmar com eles obrigações contratuais de segurança da informação e
                            proteção de Dados Pessoais, com o objetivo de minimizar riscos para titulares.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Entregadores.</b> Da mesma forma com o que ocorre com os estabelecimentos comerciais,
                            para que
                            os produtos adquiridos por meio de nosso aplicativo possam ser entregues, Dados Pessoais de
                            nossos clientes podem também ser compartilhados com entregadores para que realizem a entrega
                            dos produtos.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Autoridades Públicas.</b> Temos que cumprir a lei. Assim, se um juiz ou uma autoridade
                            com
                            competência legal exigir que o Extra compartilhe certos Dados Pessoais para, por exemplo,
                            uma investigação, vamos compartilhar. Somos contra qualquer abuso de autoridade e, caso o
                            James entenda que determinada ordem é abusiva, vamos sempre defender a privacidade dos
                            titulares.
                        </p>
                    </li>
                </ul>
                <p>
                    Além disso, reservamo-nos o direito de compartilhar quaisquer Dados Pessoais que acreditarmos serem
                    necessários para cumprir uma obrigação legal, fazer cumprir ou aplicar nossos termos de uso ou,
                    ainda, proteger os direitos, propriedade ou segurança do James, nossos funcionários e clientes.
                </p>
            </li>
            <li>
                <h3>Os seus Dados Pessoais podem ser transferidos para outros países?</h3>
                <p>Sim. Embora o James possua sua sede no Brasil e os seus produtos e serviços sejam destinados a
                    pessoas localizadas no Brasil, aplicando-se, portanto, as leis brasileiras relacionadas à proteção
                    de Dados Pessoais, os Dados Pessoais que coletamos podem ser transferidos para países localizados
                    nos EUA. Essa transferência ocorre por conta de certos fornecedores e parceiros comerciais do James,
                    que podem prestar seus serviços nesses locais. Para entender mais sobre essas transferências e para
                    quais países seus Dados Pessoais podem ser transferidos, acesse a Política de Privacidade do
                    GPA.</p>
            </li>
            <li>
                <h3>Por quanto tempo os seus Dados serão armazenados?</h3>
                <p>
                    O James possui uma política de retenção e descarte de Dados Pessoais alinhada com a lei aplicável.
                    Dados Pessoais são armazenados somente pelo tempo que for necessário para cumprir com as finalidades
                    para as quais foram coletados, salvo se houver qualquer outra razão para sua manutenção como, por
                    exemplo, cumprimento de quaisquer obrigações legais, regulatórias, contratuais, entre outras, desde
                    que fundamentadas com uma base legal. Claro, sempre há o seu direito de solicitar a exclusão dos
                    dados, conforme o item 2.
                </p>
                <p>
                    De qualquer forma, se você registrou uma conta no Extra, as informações da sua conta serão mantidas
                    enquanto você mantiver essa conta ativa.
                </p>
                <p>
                    Temos dois recados importantes para o caso de você solicitar a exclusão dos seus dados e/ou da sua
                    conta: (i) podemos eventualmente fazer verificações para checar sua real identidade, a fim de
                    garantir que não haja fraudes, e (ii) alguns Dados Pessoais não poderão ser excluídos por conta de
                    obrigações legais, mas nesses casos vamos manter nosso compromisso de sigilo e de proteção desses
                    dados.
                </p>
            </li>
            <li>
                <h3>Como seus Dados Pessoais são protegidos?</h3>
                <p>Nossa responsabilidade é cuidar dos seus Dados Pessoais, e utilizá-los somente para as finalidades
                    descritas nessa Política. E para garantir a sua privacidade e a proteção dos seus Dados Pessoais,
                    adotamos as práticas de segurança adequadas para nosso mercado, com o uso de técnicas de
                    criptografia e outros sistemas de segurança da informação.</p>
                <p>
                    Nós nos esforçamos para proteger a privacidade de seus Dados Pessoais, mas infelizmente não podemos
                    garantir total segurança. Entrada ou uso não autorizado de terceiros em sua conta, falha de hardware
                    ou software que não esteja sob controle do James e outros fatores podem comprometer a segurança dos
                    seus Dados Pessoais. Por isso, sua atuação é fundamental para a manutenção de um ambiente seguro
                    para todos. Você pode nos ajudar adotando boas práticas de segurança em relação a sua conta e aos
                    seus dados (como, por exemplo, não compartilhar sua senha com terceiros), e caso você identifique ou
                    tome conhecimento de algo que comprometa a segurança dos seus dados, por favor entre em contato
                    conosco através do e-mail <a href="mailto:cliente@jamesdelivery.com.br"> {{
                        'cliente@jamesdelivery.com.br'
                    }}</a>.
                </p>
            </li>
            <li>
                <h3>Em caso de dúvidas, com quem você pode falar?</h3>
                <p>
                    Se você acredita que seus Dados Pessoais foram usados de maneira incompatível com esta Política de
                    Privacidade ou com as suas escolhas enquanto Titular destes Dados Pessoais, ou, ainda, se você tiver
                    outras dúvidas, comentários ou sugestões relacionadas a esta Política, entre em contato conosco. Nós
                    temos um encarregado (Data Protection Officer) que está à disposição nos seguintes canais de
                    contato:
                </p>
                <ul>
                    <li>
                        <p>
                            <b>DPO (encarregado):</b> Marcelo Simões Pato
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Endereço para correspondências:</b> Avenida Brigadeiro Luis Antônio, 3142, Jardim
                            Paulista, CEP
                            01402-000 – São Paulo/SP.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Canal de atendimento:</b> <a href="mailto:dpo@gpabr.com"> {{ 'dpo@gpabr.com' }}</a>
                        </p>
                    </li>
                </ul>
            </li>
            <li>
                <h3>Mudanças neste Aviso</h3>
                <p>Como estamos sempre buscando melhorar nossos produtos e serviços, este Aviso de Privacidade pode
                    passar por atualizações para refletir as melhorias realizadas. Desta forma, recomendamos a visita
                    periódica desta página para que você tenha conhecimento sobre as modificações efetivadas.</p>
            </li>
        </ol>

    </div>
</div>